__webpack_require__.p = "https://gamma.jp.safer.whs.amazon.dev/";